import React from 'react';
import './KindergartenCard.css';

const KindergartenCard = ({ kindergarten, highlighted = false }) => {
  return (
    <div className={`kindergarten-card ${highlighted ? 'highlighted' : ''}`}>
      <a href={`/object/${kindergarten._id}`} className="card-title-link">{[kindergarten.number, kindergarten.name].join(" ")}</a>
      <p className="card-district">{kindergarten.contacts.address.district}</p>
      <p className="card-address">{kindergarten.contacts.address.string}</p>
      <p className="card-phone">{kindergarten.contacts.phones.join(",")}</p>
    </div>
  );
};

export default KindergartenCard;